/**
 * ResponsivePaymentSheet - Componente de pagamento responsivo
 * - Desktop: usa Dialog (modal centralizado)
 * - Tablet/Mobile: usa Drawer (bottom sheet)
 */
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerFooter,
} from "@/components/ui/drawer";

const TABLET_BREAKPOINT = 1024; // lg breakpoint

export function useIsTablet() {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsTablet(window.innerWidth < TABLET_BREAKPOINT);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return isTablet;
}

/**
 * ResponsivePaymentSheet - Wrapper para pagamento responsivo
 */
export function ResponsivePaymentSheet({
  open,
  onOpenChange,
  title,
  children,
  footer,
  className = "",
}) {
  const isTablet = useIsTablet();

  if (isTablet) {
    // Drawer (bottom sheet) para tablet/mobile
    return (
      <Drawer open={open} onOpenChange={onOpenChange}>
        <DrawerContent className={className}>
          <DrawerHeader className="text-center border-b pb-4">
            <DrawerTitle className="text-lg font-bold uppercase">
              {title}
            </DrawerTitle>
          </DrawerHeader>
          <div className="p-4 overflow-auto max-h-[60vh]">
            {children}
          </div>
          {footer && (
            <DrawerFooter className="border-t pt-4">
              {footer}
            </DrawerFooter>
          )}
        </DrawerContent>
      </Drawer>
    );
  }

  // Dialog (modal) para desktop
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`max-w-lg ${className}`}>
        <DialogHeader>
          <DialogTitle className="uppercase font-bold">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="py-2">
          {children}
        </div>
        {footer && (
          <DialogFooter className="mt-4">
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ResponsivePaymentSheet;
